import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { PageResponse } from '@core/entities/pagination'
import {
  competencyTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/competencyTemplates'
import {
  CompetencyTemplateVersion,
  ICompetencyTemplateVersion,
} from '@core/entities/competency/CompetencyTemplateVersion'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const dataTransformer = (
  response: PageResponse<ICompetencyTemplateVersion>,
) => ({
  ...response,
  content: response.content.map((version) =>
    CompetencyTemplateVersion.new(version),
  ),
})

export const useGetCompetencyTemplateVersions = (
  params: RequestTypes['getCompetencyTemplateVersions'],
  options: UseQueryOptions<
    PageResponse<ICompetencyTemplateVersion>,
    RequestErrorType,
    PageResponse<CompetencyTemplateVersion>
  > = {},
) => {
  return useQuery<
    PageResponse<ICompetencyTemplateVersion>,
    RequestErrorType,
    PageResponse<CompetencyTemplateVersion>
  >({
    select: dataTransformer,
    ...competencyTemplateKeys.getVersions(params),
    ...options,
  })
}
